import {
  
  GET_PAGE_DEFINITIONS,
  GET_PAGE_DEFINITIONS_SUCCESS,
  ADD_NEW_PAGE_DEFINITION,
  ADD_PAGE_DEFINITION_SUCCESS,
  UPDATE_PAGE_DEFINITION,
  UPDATE_PAGE_DEFINITION_SUCCESS,
  DELETE_PAGE_DEFINITION,
  DELETE_PAGE_DEFINITION_SUCCESS,
  PAGE_API_ERROR


} from "./actionTypes"




export const getPageDefinitions = () => ({
  type: GET_PAGE_DEFINITIONS,
})

export const getPageDefinitionsSuccess = pageDefinition => ({
  type: GET_PAGE_DEFINITIONS_SUCCESS,
  payload: pageDefinition,
})

export const addNewPageDefinition = pageDefinition => ({
  type: ADD_NEW_PAGE_DEFINITION,
  payload: pageDefinition,
})

export const addPageDefinitionSuccess = pageDefinition => ({
  type: ADD_PAGE_DEFINITION_SUCCESS,
  payload: pageDefinition,
})


export const updatePageDefinition = pageDefinition => ({
  type: UPDATE_PAGE_DEFINITION,
  payload: pageDefinition,
})

export const updatePageDefinitionSuccess = pageDefinition => ({
  type: UPDATE_PAGE_DEFINITION_SUCCESS,
  payload: pageDefinition,
})


export const deletePageDefinition = guid => ({
  type: DELETE_PAGE_DEFINITION,
  payload: guid,
})

export const deletePageDefinitionSuccess = guid => ({
  type: DELETE_PAGE_DEFINITION_SUCCESS,
  payload: guid,
})

export const pageManagementError = error => {
  return {
    type: PAGE_API_ERROR,
    payload: error,
  }
}

